export const RefriKey = {
  EMISSION_SOURCE: 'emissionSource',
  NO_UNITS: 'numberOfUnit',
  REFRI_USED: 'refrigerantUsed',
  FREQUENCY_INSPE: 'frequencyOfInspections',
  FREQUENCY_NO: 'frequencyNumber',
  REFRI_CHARGE: 'refrigerantCharge',
  DATE_INSTALLATION: 'dateOfInstallation',
  QUANTITY_TF: 'quantity',
  STATUS: 'status',
  COMMENT: 'comment'
};

export const RefriLabel = {
  EMISSION_SOURCE: 'Type of Equipment',
  NO_UNITS: 'No. of Units',
  REFRI_USED: 'Refrigerant Used',
  FREQUENCY_INSPE: 'Frequency of Inspections',
  FREQUENCY_NO: 'Frequency Number',
  REFRI_CHARGE: 'Total Refrigerant Charge',
  DATE_INSTALLATION: 'Date of Installation',
  QUANTITY_TF: 'Quantity',
  STATUS: 'Status',
  COMMENT: 'comment',
  STATUS_COMMENTS: 'Status & Comments'
};
